import { render } from "./InputItem.vue?vue&type=template&id=56a81b3f"
import script from "./InputItem.vue?vue&type=script&lang=js"
export * from "./InputItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__